import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { ListData, TableActionData } from '@pt/pt-models';
import { UpsertUserColumnRequest } from 'it/primatoo/openapi/api/org/schemas/common/UpsertUserColumnRequest';

@Directive()
export abstract class TableInputDirective<E> {
  @Input() defaultRowId!:
    | number
    | string; /*organization utilizza UUID come ID ed è una stringa*/
  @Input() data!: ListData<E>;
  @Input() useCheckboxColumn = false;

  @Input() externalFilterModel: any;
  @Input() externalSortModel: any;

  // questo output va messo anche nella classe che estende table utils. Non so bene perchè non lo veda
  // ma se non viene messo non propaga (GEG)
  @Output() clickAction: EventEmitter<TableActionData<E>> = new EventEmitter<
    TableActionData<E>
  >();
  @Output() userColumnsVisible: EventEmitter<UpsertUserColumnRequest> =
    new EventEmitter<UpsertUserColumnRequest>();
  @Output() resetColumns: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() selectData: EventEmitter<E[]> = new EventEmitter<E[]>();

  @Output() filterChange = new EventEmitter<any>();
  @Output() sortChange = new EventEmitter<any>();
}
